import { Component } from '@angular/core';
import { PaypalOption } from './paypal-option.model';
import { RouterConst } from '../../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

declare let $: any;

@Component({
  selector: 'app-analytics-paypal-options',
  templateUrl: './paypal-options.component.html',
  styleUrls: ['./paypal-options.component.css'],
})
export class AnalyticsPaypalOptionsComponent extends SuperClass {
  options: any;
  selectedRow: PaypalOption;
  newAccount: PaypalOption;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;
  currencies: any[] = [];
  downloadLimits: any[] = [];
  downloadSpeedLimits: any[] = [];
  timeLimits: any[] = [];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Paypal Options',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_PAYPAL_OPTIONS] } },
        ],
      },
    ]);
    this.newAccount = new PaypalOption();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllAccounts('paypalOptions', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.options = data.payload;
      }
    });
    this.http_getPaypalCurrencies((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const currency = {};
          currency['label'] = element;
          currency['value'] = element;
          this.currencies.push(currency);
        });
      }
    });
    this.http_getTimeLimits('paypalOptions', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const limit = {};
          limit['label'] = element;
          limit['value'] = element;
          this.timeLimits.push(limit);
        });
      }
    });
    this.http_getDownloadLimits('paypalOptions', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const limit = {};
          limit['label'] = element;
          limit['value'] = element;
          this.downloadLimits.push(limit);
        });
      }
    });
    this.http_getSpeedLimits('paypalOptions', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const limit = {};
          limit['label'] = element;
          limit['value'] = element;
          this.downloadSpeedLimits.push(limit);
        });
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      timeLimitValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      timeLimitUnitType: new FormControl('', Validators.required),
      downloadValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downloadUnitType: new FormControl('', Validators.required),
      downSpeedValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downSpeedUnitType: new FormControl('', Validators.required),
      price: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('[0-9]+(\\.[0-9]+$)?'),
          Validators.min(0.00000001),
        ]),
      ),
      currency: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      timeLimitValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      timeLimitUnitType: new FormControl('', Validators.required),
      downloadValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downloadUnitType: new FormControl('', Validators.required),
      downSpeedValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downSpeedUnitType: new FormControl('', Validators.required),
      price: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('[0-9]+(\\.[0-9]+$)?'),
          Validators.min(0.00000001),
        ]),
      ),
      currency: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new PaypalOption(e.data);
  }

  saveAccount() {
    // const requiredFields = [
    //   {id: 'name', value: this.selectedRow.name, fieldName: 'Name'},
    //   {id: 'timeLimit', value: this.selectedRow.timeLimitValue, fieldName: 'Time Limit Value'},
    //   {id: 'timeLimitUnitType', value: this.selectedRow.timeLimitUnitType, fieldName: 'Time Limit Unit Type'},
    //   {id: 'downloadValue', value: this.selectedRow.downloadValue, fieldName: 'Download Value'},
    //   {id: 'downloadUnitType', value: this.selectedRow.downloadUnitType, fieldName: 'Download Unit Type'},
    //   {id: 'downSpeedValue', value: this.selectedRow.downSpeedValue, fieldName: 'Download Speed Limit Value'},
    //   {id: 'downSpeedUnitType', value: this.selectedRow.downSpeedUnitType, fieldName: 'Download Speed Unit Type'},
    //   {id: 'price', value: this.selectedRow.price, fieldName: 'Price'},
    //   {id: 'currency', value: this.selectedRow.currency, fieldName: 'Currency'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_updateAccounts(this.selectedRow, 'paypalOptions', (data: any) => {
      this.showSuccessMessage('Option has been updated');
      this.unselectRow();
      this.options = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new PaypalOption();
  }

  createNewAccount() {
    // const requiredFields = [
    //   {id: 'new_name', value: this.newAccount.name, fieldName: 'Name'},
    //   {id: 'new_timeLimit', value: this.newAccount.timeLimitValue, fieldName: 'Time Limit Value'},
    //   {id: 'new_timeLimitUnitType', value: this.newAccount.timeLimitUnitType, fieldName: 'Time Limit Unit Type'},
    //   {id: 'new_downloadValue', value: this.newAccount.downloadValue, fieldName: 'Download Value'},
    //   {id: 'new_downloadUnitType', value: this.newAccount.downloadUnitType, fieldName: 'Download Unit Type'},
    //   {id: 'new_downSpeedValue', value: this.newAccount.downSpeedValue, fieldName: 'Download Speed Limit Value'},
    //   {id: 'new_downSpeedUnitType', value: this.newAccount.downSpeedUnitType, fieldName: 'Download Speed Unit Type'},
    //   {id: 'new_price', value: this.newAccount.price, fieldName: 'Price'},
    //   {id: 'new_currency', value: this.newAccount.currency, fieldName: 'Currency'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_addAccount(this.newAccount, 'paypalOptions', (data: any) => {
      this.showSuccessMessage('Option has been updated');
      this.unselectRow();
      this.options = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(
      { id: this.selectedRow.id },
      'paypalOptions',
      (data: any) => {
        this.showSuccessMessage('Option has been deleted');
        this.unselectRow();
        this.options = data.payload;
      },
    );
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}

export class Currency {
  name: string;
  value: string;

  constructor(name, value) {
    this.name = name;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/paypal-options/paypal-options.component.ts